import { KpiPeriodSelector } from "../kpi-period-selector";

interface Props {
  dateRange: string;
  setDateRange: (value: string) => void;
}

export const ExportChannelInsightsPeriodSelector = ({
  dateRange,
  setDateRange,
}: Props) => (
  <div className="pb-8">
    <div className="text-lg font-semibold mb-2">Select time period</div>
    <KpiPeriodSelector
      value={dateRange}
      onChange={(value) => setDateRange(value)}
    />
  </div>
);
